/* BEATSEEK — "Where to get it" logo row for the ID result card. */
import React from 'react';
import { Music, Share2 } from 'lucide-react';

const STORES = [
  { id: 'spotify', name: 'Spotify', logo: '/logos/spotify-logo.png', url: (q) => `https://open.spotify.com/search/${q}` },
  { id: 'discogs', name: 'Discogs', logo: '/logos/discogs-icon-mono.svg', url: (q) => `https://www.discogs.com/search/?q=${q}&type=all` },
  { id: 'deezer', name: 'Deezer', logo: '/logos/deezer-logo.svg', url: (q) => `https://www.deezer.com/search/${q}` },
  { id: 'traxsource', name: 'Traxsource', logo: '/logos/traxsource-logo.png', url: (q) => `https://www.traxsource.com/search?term=${q}` },
  { id: 'beatport', name: 'Beatport', logo: '/logos/beatport-icon-clean.png', url: (q) => `https://www.beatport.com/search?q=${q}` },
  { id: 'bandcamp', name: 'Bandcamp', logo: '/logos/bandcamp-logo.svg', url: (q) => `https://bandcamp.com/search?q=${q}` },
];

export const GetItRow = ({ track, onSaveToSpotify, onShareToDiscord }) => {
  if (!track || !track.title) return null;
  const q = encodeURIComponent(`${track.artist || ''} ${track.title || ''}`.trim());

  return (
    <div className="id-getit" data-testid="id-getit-row">
      <span className="id-getit-label">Where to get it</span>
      <div className="id-getit-logos">
        {STORES.map((s) => (
          <a
            key={s.id}
            href={s.url(q)}
            target="_blank"
            rel="noopener noreferrer"
            className="id-getit-link"
            title={`${s.name} — search this track`}
            aria-label={s.name}
            data-testid={`purchase-${s.id}`}
          >
            <img src={s.logo} alt={s.name} loading="lazy" />
          </a>
        ))}
        {(onSaveToSpotify || onShareToDiscord) && <span className="id-extras-sep" aria-hidden="true">|</span>}
        {onSaveToSpotify && (
          <button
            type="button"
            className="id-getit-link id-getit-action"
            onClick={onSaveToSpotify}
            title="Save to a Spotify playlist"
            aria-label="Save to Spotify"
            data-testid="save-to-spotify-btn"
          >
            <Music size={15} style={{ color: '#1db954' }} />
          </button>
        )}
        {onShareToDiscord && (
          <button
            type="button"
            className="id-getit-link id-getit-action"
            onClick={onShareToDiscord}
            title="Share to Discord"
            aria-label="Share to Discord"
            data-testid="share-to-discord-btn"
          >
            <Share2 size={15} style={{ color: '#8f9bf7' }} />
          </button>
        )}
      </div>
    </div>
  );
};

export default GetItRow;
